import { CustomerDataTable } from "@/components";

const Customers = () => {
 return (
  <div className="datatable-crud">
   <div className="card">
    <CustomerDataTable />
   </div>
  </div>
 );
};

export default Customers;
